import * as React from 'react';
import { RememberedAccountsContainer } from './containers/RememberedAccountsContainer';
import { trackRememberedAccountsOpen } from './tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export var RememberedAccountsView = function RememberedAccountsView(_ref) {
  var source = _ref.source;
  React.useEffect(function () {
    trackRememberedAccountsOpen(source);
  }, []);
  return /*#__PURE__*/_jsx(RememberedAccountsContainer, {});
};